import React from 'react';
import './FoldLoader.css';
import { FoldLoaderLines } from '../FoldLoaderLines';
import { foldLoaderVariantsEnum } from '../../../../../shared/src/enums/promotions.enum';

export const FoldLoader = () => {
    return (
        <div className="asg-promotion-fold__loader">
            <div className="asg-promotion-fold__loader-section asg-promotion-fold__loader-section--main">
                <div className="asg-promotion-fold__loader-section-main">
                    <div className="asg-promotion-fold__loader-section-main-gradient-wrap">
                        <div className="asg-promotion-fold__loader-gradient" />
                        <div className="asg-promotion-fold__loader-icon" />
                    </div>
                    <div className="asg-promotion-fold__loader-section-main-lines">
                        <div className="asg-promotion-fold__loader-lines-wrap
                            asg-promotion-fold__loader-lines-wrap--main">
                            <FoldLoaderLines />
                        </div>
                    </div>
                </div>
            </div>
            <div className="asg-promotion-fold__loader-section asg-promotion-fold__loader-section--next">
                <div className="asg-promotion-fold__loader-section-next-lines">
                    <div className="asg-promotion-fold__loader-lines-wrap asg-promotion-fold__loader-lines-wrap--next">
                        <FoldLoaderLines
                            linesVariationName={foldLoaderVariantsEnum.DOTTED_SIMPLE}
                            className="asg-promotion-fold__loader-lines--mobile"
                        />
                        <FoldLoaderLines
                            linesVariationName={foldLoaderVariantsEnum.DOTTED_2ND_LINE_SPLIT}
                            className="asg-promotion-fold__loader-lines--desktop"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
